/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneCheckbox from 'base/components/standalone/Checkbox';

export const DynamicStandaloneCheckbox = StandaloneCheckbox;
export type DynamicStandaloneCheckboxProps = PropsFromComponent<typeof StandaloneCheckbox>;

export const DynamicStandaloneCheckboxWith = (extras: DynamicStandaloneExtras): typeof StandaloneCheckbox => {
    return function DynamicStandaloneCheckbox(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Checkbox');
        return <StandaloneCheckbox {...mergeProps({ options: { theme } }, props)} />;
    }
}